/**
 * コンテンツ中央寄せ
 * @module alignCenter
 * @param {string} targetElementId - 対象要素のID
 * @description overflow-xがautoに設定されている要素を中央に寄せる
*/
export function alignCenter(targetElementId) {
	// 指定した要素を取得
	const targetElement = document.getElementById(targetElementId);

	if (targetElement !== null) {
		// 要素のコンテンツの幅を取得
		const contentWidth = targetElement.scrollWidth;

		// 要素の表示領域の幅を取得
		const viewportWidth = targetElement.clientWidth;

		// 中央にスクロールする位置を計算
		const scrollLeft = (contentWidth - viewportWidth) / 2;

		// スクロール位置を設定
		targetElement.scrollLeft = scrollLeft;
	}
}